<template>
<div class="Information container">
  <center>
<card title="Kundeninformationen" :subTitle="subtitle" id="frame" >
  
  <table >
    <tr>
      <td>Kundennr:&nbsp;&nbsp;&nbsp; </td>
      <td>{{kunde.Kunden_Nr}}</td>
    </tr>
    <tr>
      <td>Adresse: </td>
      <td>{{kunde.Strasse}} {{kunde.Hausnummer}}</td>
    </tr>
    <tr>
      <td>Bezirk: </td>
      <td>{{kunde.Bezirk}}</td>
    </tr>
    <tr>
      <td>PLZ: </td>
      <td>{{kunde.PLZ}}</td>
    </tr>
    <tr>
      <td>Stadt: </td>
      <td>{{kunde.Stadt}}</td>
    </tr>
    <tr>
      <td>Telefon: </td>
      <td>{{kunde.Telefon}}</td>
    </tr>
    <tr>
      <td>Telefon2: </td>
      <td>{{kunde.Telefon2}}</td>
    </tr>
  </table>
  {{kunde.Bemerkung}}
  <v-btn fab dark color="blue" v-on:click="gotoMaps(kunde.Strasse, kunde.Hausnummer, kunde.PLZ, kunde.Stadt);">
                        <v-icon id="icons" dark>navigation</v-icon>
                </v-btn>
                <v-btn fab dark color="green" v-bind:href="'tel:' + kunde.Telefon">
                        <v-icon id="phone" dark>phone</v-icon>
  </v-btn>
  
</card>
</center>
</div>
</template>

<script>

export default {
  name: "Information",
  components: {

  },
  data() {
    return {
        kunde: {},
        subtitle: ""
    
    };
  },
  methods: {
      gotoMaps(Strasse, Hausnummer, PLZ, Stadt) {
     
          window.location.href = "https://www.google.com/maps/dir/?api=1&destination=" + Strasse + "+"+ Hausnummer+ "+"+PLZ+"+" + Stadt+ "+Germany&travelmode=driving";
      },
      fetchCustomer(kundennr){
      this.$http.post(process.env.VUE_APP_PHP_API_URL+'/kunden/'+ kundennr, {auth: process.env.VUE_APP_PHP_AUTH})
        .then(function(response){
            console.log(response.body);
            this.kunde = response.body;
            this.subtitle = response.body.Vorname + " " + response.body.Nachname + " - "+ response.body.Firma;
            });
    },
  },

  created: function(){
      this.fetchCustomer(this.$route.params.kundennr);
  },
  // updated: function(){
  // }
};
</script>

<style scoped>
#phone{
  position: absolute;
  top: 15px;
  
}
</style>
